(function ($, Drupal) {

  'use strict';
  var window_resize;
  var drupal_settings;

  Drupal.behaviors.overlapping_backgrounds = {
    attach: function (context, settings) {
      drupal_settings = settings;
      p_backgrounds_size();

      this.callPBackgroundsSize = function () {
        p_backgrounds_size();
      };
    }
  };


  function p_backgrounds_size() {
    $('.pg-bg').each(function () {
      $(this).css('height', 0);
      var paragraph = $(this).parent();
      var height = 0;
      var pids = $(this).attr('data-pids').split('-');

      // If paragraph = first -> Add header height to bg
      if (paragraph.hasClass('first') && $('body:not(.node-type-product)').length) {
        height += $('.page_header').outerHeight();
      }

      $.each(pids, function (key, value) {
        height += $('.paragraph[data-id="' + value + '"]').outerHeight();
      });

      $(this).css('height', height);
    });
  }

  $(document).ready(function () {
    window.onresize = function () {
      clearTimeout(window_resize);
      window_resize = setTimeout(p_backgrounds_size, 100);
    };
  });

})(jQuery, Drupal);
